export default __webpack_public_path__ + "static/media/inequality-icon.6872a00e.svg";